import { render, staticRenderFns } from "./ConfirmRegionalManager.vue?vue&type=template&id=197d2c09&"
import script from "./ConfirmRegionalManager.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegionalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports